import {
  ModalLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import usePendingTable from "./usePendingTable";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../OrderColumn";
import Style from "../staffWindow.module.scss";
import RemarksTableRecheck from "../../RemarksTableRecheck";
import { Table } from "../../Table";

const PendingTable = () => {
  const {
    isLoading,
    isFetching,
    staffState,
    tableFields,
    showEditModal,
    pendingTableData,
    globalRemarkModal,
    paginationOptions,
    getRow,
    refetch,
    handleSearch,
    handlePageSize,
    handleModalClose,
    handlePagination,
    handleAssignClick,
    updatePendingFields,
    handleEditColumnsClick,
    handleBulkAssignRecheckAll,
  } = usePendingTable();

  return (
    <div>
      <SearchFilters
        onSearchInput={handleSearch}
        SearchIcon={<span className="material-symbols-outlined"> search </span>}
        showClearFilters={false}
        searchInputProps={{ value: staffState?.pendingSearch, placeholder: "Search Certificate Number" }}
        showActions={true}
        handleActionClick={handleEditColumnsClick}
        loading={isLoading}
        filterChildren={
          <div className="col-auto pro-ms-auto">
            <button
              className={`${Style.Print_btn} pro-btn pro-items-center pro-btn-outline `}
              onClick={handleBulkAssignRecheckAll}
            >
              <span className="material-symbols-outlined">check_circle</span>
              <span>Assign All</span>
            </button>
          </div>
        }
      />
      <Table
        multiSelect={pendingTableData?.data?.data?.length !== 0 ? true : false}
        data={pendingTableData?.data?.data ?? []}
        uniqueID={"id"}
        fields={tableFields}
        SortIcon={<FaSort />}
        assignIcon={<span className="material-symbols-outlined">badge</span>}
        getRow={getRow}
        loading={isFetching}
        perpage={staffState?.currentPageSize}
        assignable={true}
        handleAssign={handleAssignClick}
        deletable={false}
        editable={false}
        showCheckBox={true}
      />
      <Pagination
        currentPage={staffState?.currentPageTab}
        totalPageCount={Math.ceil(
          pendingTableData?.data?.total_count /
            pendingTableData?.data?.per_page,
        )}
        onPageChange={handlePagination}
        options={paginationOptions}
        onActionChange={handlePageSize}
        center
      />
      <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
        <div className="pro-m-5">
          <OrderColumn
            title={"Choose which columns you see"}
            refetchData={refetch}
            tableFields={pendingTableData?.data?.fields}
            moduleId={pendingTableData?.data?.module_id}
            updateData={updatePendingFields}
          />
        </div>
      </ModalLayout>
      <ModalLayout
        show={globalRemarkModal}
        handleClose={handleModalClose}
        title={"Remarks"}
        propStyle={{ root: "pro-modal-xxl" }}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <div className="pro-m-5">
          <RemarksTableRecheck />
        </div>
      </ModalLayout>
    </div>
  );
};

export default PendingTable;
